import Box   from '@mui/material/Box'
import '../../App.css'
import '../../style.css';

function B_Button({onClick}) {

  // Bボタンクリック時の処理
  const handleClick_B_Button = (e) => {
    console.log("Bボタン")
    onClick() // 親コンポーネントから渡された関数を呼び出す
  }

  return (
      <Box sx={{ m : 1 , p : 4}}>
        {/* Bボタン */}
        <Box
          onClick={handleClick_B_Button} // ボタンのクリックイベント  
          sx={{
            m: 1, // 外側の余白
            p: 1, // 内側の余白
            fontFamily     : 'Meiryo'   , // メイリオ
            borderRadius   : "30px"     ,
            bgcolor        : '#000000'  ,
            height         : "40px"     ,
            width          : '40px'     ,
            fontSize       : "20px"     ,
            position       : 'absolute' , // 絶対位置指定
            top            : '480px'    , // 縦位置を50pxに指定
            left           : '250px'    , // 横位置を20pxに指定
            display        : 'flex'     , // フレックスボックスを使用
            alignItems     : 'center'   , // 垂直方向の中央揃え
            justifyContent : 'center'   , // 水平方向の中央揃え
            color          : '#333631'  , // テキストカラーをグレーに設定
          }}>B
        </Box>
      </Box>
  );
}

export default B_Button;
